export default __webpack_public_path__ + "static/media/feature.6d2b0f21.png";